<template>
  <div class="can-pedalsure hp-block-container">
    <h2 class="hp-block-title">What does commuter cycle insurance cover?</h2>
    <div class="hp-prose">
      <p>
        We love people who ride bikes to work, they’re like city-slicking
        superheroes. Whether you ride 5 or 50 miles a day to and from work,
        you’re getting there sustainably, and for that, we applaud you.
      </p>
      <p>
        Unfortunately, it’s not all nice summer rides and gorgeous sunrises, for
        what feels like nine months out of the year it’s colder than we’d like –
        and sometimes we just get wet.
      </p>
      <p>
        But whether you ride to work once a week or every day, it’s worth
        insuring your bike against theft or damage at the workplace, as well as
        providing cover if you were to be involved in a collision.
      </p>
    </div>
    <div class="element-container hp-cards">
      <div>
        <b>Theft</b>: If your bike gets stolen while you’re at work and it’s
        securely stored in line with what it says in your policy document,
        you’ll be covered.
      </div>
      <div>
        <b>Damage</b>: Bike damaged on the commute? Don’t worry, we’ve got your
        back.
      </div>
      <div>
        <b>Personal injury</b>: Slid over a drain cover in the wet? We’ve all
        done it. We’ll cover you for your injuries.
      </div>
      <div>
        <b>Public liability</b>: If someone else gets injured or their property
        is damaged, we'll take care of it.
      </div>
      <div>
        <b>Loss of earnings</b>: If you injure yourself and can’t work we can
        provide a weekly payment to get you back on your feet.
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.can-pedalsure {
  border-top: 1px solid $ps-border;
  border-bottom: 1px solid $ps-border;
}

.title {
  text-align: center;
  font-family: $family-regular;
  margin: 20px 0 0 0;
  font-size: 1.6rem;
  @include tablet {
    margin: 50px 0;
    font-size: 2.5rem;
  }
}
.subtitle {
  color: $ps-gray;
  line-height: 2rem;
}
</style>
